import { IHttpService } from "angular"

/**
 * A service that provides data for leads policies.
 */
export class LeadsPolicyService {
    /**
     * Create a new leads policy service implemented using the REST API.
     * @param {IHttpService} $http The HTTP client service.
     * @param {string} apexApiUrl The root URL for the Apex API
     */
    constructor(private $http: IHttpService, private apexApiUrl: string) {
        'ngInject'
        this.$http = $http
        this.apexApiUrl = apexApiUrl
    }

    /**
     * Get a leads policy with the given ID
     * @param {number} leadsPolicyID The ID for the leads policy
     * @returns {Promise<any>} The resolved leads policy.
     */
    retrieveLeadsPolicy(leadsPolicyID) {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/leads-policies/${leadsPolicyID}`
        }).then(response => response.data)
    }

    /**
     * Get a leads policy with the given ID
     * @param {number} divisionID The ID for the division.
     * @returns {Promise<any>} The resolved leads policy.
     */
    retrieveDivisionLeadsPolicy(divisionID) {
        return this.$http({
            method: "GET",
            url: `${this.apexApiUrl}/divisions/${divisionID}/leads-policy`,
        }).then(response => response.data)
    }

    /**
     * Create or replace the leads policy for the specific division.
     * @param {number} divisionID The ID for the leads policy being defined.
     * @param {any} request The request body for the update.
     */
    defineDivisionLeadsPolicy(divisionID, request) {
        return this.$http({
            method: "PUT",
            url: `${this.apexApiUrl}/divisions/${divisionID}/leads-policy`,
            data: request
        }).then(response => response.data)
    }

    /**
     * Update the leads policy according to the request body.
     * @param {number} leadsPolicyID The ID for the leads policy being updated
     * @param {any} request The request body for the update.
     */
    updateLeadsPolicy(leadsPolicyID, request) {
        return this.$http({
            method: "PUT",
            url: `${this.apexApiUrl}/leads-policies/${leadsPolicyID}`,
            data: request
        }).then(response => response.data)
    }

    /**
     * Remove the leads policy for the specific division.
     * @param {number} divisionID The ID for the leads policy being defined.
     * @param {any} request The request body for the update.
     */
    removeDivisionLeadsPolicy(divisionID) {
        return this.$http({
            method: "DELETE",
            url: `${this.apexApiUrl}/divisions/${divisionID}/leads-policy`
        }).then(response => response.data)
    }

    retrieveLeadsPolicyImportSchemas(leadsPolicyID: number) {
        return this.$http<any[]>({
            method: "GET",
            url: `${this.apexApiUrl}/leads-policies/${leadsPolicyID}/import-schemas`
        }).then(response => response.data);
    }
}
